import {apiVoissa} from "../../libs/api";


export const fetchHomeStories = (config = {}) => apiVoissa.get(`/features/stories`, config);
export const fetchHomeMediasCreator = (config = {}) => apiVoissa.get(`/features/medias-creator`, config);
export const fetchHomeMediasNoCreator = (config = {}) => apiVoissa.get(`/features/medias-no-creator`, config);
export const fetchHomeMediasVideos = (config = {}) => apiVoissa.get(`/features/medias-videos`, config);
export const fetchHomeTopics = (config = {}) => apiVoissa.get(`/features/topics`, config);
export const fetchHomeStatus = (config = {}) => apiVoissa.get(`/features/status`, config);

export const FEATURE_STORIES_KEY = `feature-stories`;
export const FEATURE_PHOTOS_CREATOR_KEY = `feature-photos-creator`;
export const FEATURE_PHOTOS_NO_CREATOR_KEY = `feature-photos-no-creator`;
export const FEATURE_VIDEOS_KEY = `feature-videos`;
export const FEATURE_TOPICS_KEY = `feature-topics`;
export const FEATURE_STATUS_KEY = `feature-status`;